import React, { useState, useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';
import Select from 'react-select';
import { Redirect } from 'react-router-dom';

import { object_type, api_crud_base, api_crud_route, data_interface, endpoints } from './Config';

import { getTokenInfo } from '../../../UseToken';

import Loader from '../../Loader/Loader';

import Swal from 'sweetalert2'

import {

	reqGET,
	reqPOST,
	reqDELETE,
	reqPUT,

	obter_cidades_por_distrito,
	obter_freguesias_por_cidade,
	//obter_distrito_por_cidade,
	obter_paises_em_pt,
	obter_distritos_pt,

	//get_vat_info,

	pattern_vat,
	pattern_email,
	passwordHash,

} from '../../../Utils';

import { language } from './Language';

import 'react-phone-number-input/style.css'
import PhoneInput from 'react-phone-number-input'

export default function Regist(props) {
	const [, set_dados] = useState(null);
	const dados = useRef(data_interface);

	const [lang, /*set_lang*/] = useState('pt');

	const [isloading, setLoading] = useState(true);
	const [isRedirect, setRedirect] = useState(false);

	const [show_delete_button, set_show_delete_button] = useState(false);

	const [is_password, /*set_is_password*/] = useState(false)
	const [new_password, set_new_password] = useState('')
	const [confirm_password, set_confirm_password] = useState('')
	const [projetoAtual, setProjetoAtual] = useState(null);
	//const [is_input_disabled, set_is_input_disabled] = useState(true);

	const [is_edit, set_is_edit] = useState(false)

	//const [newDate, ] = useState(new Date())
	//const [today , ] = useState(newDate.getFullYear() + '-' + (newDate.getMonth() + 1).toString().padStart(2, "0") + '-' + newDate.getDate().toString().padStart(2, "0"))

	const [/*show_district_city_village*/, set_show_district_city_village] = useState('');

	const [/*disabled*/, set_disabled] = useState(false)

	const entity_types = [
		{ value: "Ski", label: "Ski" },
		{ value: "Snowboard", label: "Snowboard" }
	];

	const identification_types = [
		{ value: "Bilhete de Identidade", label: "Bilhete de Identidade" },
		{ value: "Cartão de Cidadão", label: "Cartão de Cidadão" }
	];


	const [countries, set_countries] = useState([])
	const [districts, set_districts] = useState([])
	const [cities, set_cities] = useState([])
	const [villages, set_villages] = useState([])
	const [departamentos, setDepartamentos] = useState([])
	const [departamentoInput, setDepartamentoInput] = useState('');
	const [isModalOpen, setIsModalOpen] = useState(false); // Modal state
	const [modalResponsavel, setModalResponsavel] = useState(false);
	const [responsavelInputEmail, setresponsavelInputEmail] = useState('');
	const [responsavelInputObs, setresponsavelInputObs] = useState('');	
	const [selectedDepartamentoId, setSelectedDepartamentoId] = useState('');	
	const [modalDepartamento, setModalDepartamento] = useState(false);
	const [modalPedidoAssistencia, setModalPedidoAssistencia] = useState(false);
	const [prioridade, setPrioridade] = useState('1');
	const [responsavelInputNome, setresponsavelInputNome] = useState('');
	const [responsavelInputTel, setresponsavelInputTel] = useState('');
	const [departamentoSelecionado, setDepartamentoSelecionado] = useState('');
	const [departamentoid, setDepartamentoId] = useState();
	const [isProjectModalOpen, setIsProjectModalOpen] = useState(false);
	const [codProjetoInput, setCodProjetoInput] = useState('');
	const [tipoIdInput, setTipoIdInput] = useState(1); // Inicializa com o primeiro tipo
	const [linhaIdInput, setLinhaIdInput] = useState(1); // Inicializa com a primeira linha
	const [nLicencaInput, setNLicencaInput] = useState('');
	const [dataInicioInput, setDataInicioInput] = useState('');
	const [dataFimInput, setDataFimInput] = useState('');
	const [assistenciaRemotaInput, setAssistenciaRemotaInput] = useState(false);
	const [tempoAssistenciaInput, setTempoAssistenciaInput] = useState('');
	const [assistenciaPermitidaInput, setAssistenciaPermitidaInput] = useState(false);
	const [refresh, setRefresh] = useState(0);


	const custom_select_styles = {
		container: base => ({
			...base,
			borderRadius: "0px",
			width: '100%',
		}),
		control: base => ({
			...base,
			borderRadius: "0px",
			padding: "2px 10px",
			fontSize: '14px'
		}),
		menu: base => ({
			...base,
			borderRadius: "0px",
		}),
	}



	const handle_change_departamento = (event) => {
		const { name, value } = event.target;
		set_dados((prevState) => ({
			...prevState,
			current: {
				...prevState.current,
				info: {
					...prevState.current.info,
					[name]: value
				}
			}
		}));
	};


	/* const filteredResponsables = dados.current.contacts[0].person_responsables.filter(responsavel =>
		responsavel.departamentos.includes(departamentoSelecionado)
	);
 */
	// Nome:Tipo
	const tipoSw = [
		{ id: 1, nome: 'SimAlimentação' },
		{ id: 2, nome: 'SimPan' },
		{ id: 3, nome: 'SimFact' },
		{ id: 4, nome: 'SimBeet' },
		{ id: 5, nome: 'SimRest' }
	];

	//Linha:SW

	const linhaSw = [
		{ id: 1, nome: 'Base' },
		{ id: 2, nome: 'Extra' },
		{ id: 3, nome: 'Light' },

	];
	// Criar projetos para a empresa 

	const clearModalFields = () => {
		setCodProjetoInput('');
		setTipoIdInput(1);
		setLinhaIdInput(1);
		setNLicencaInput('');
		setDataInicioInput('');
		setDataFimInput('');
		setAssistenciaRemotaInput(false);
		setTempoAssistenciaInput('');
		setAssistenciaPermitidaInput(false);
		setProjetoAtual(null); // Reseta o projeto atual
	};



	const AddProjeto = () => {
		// Verifica se `dados.current.info.projetos` está definido como um array, caso contrário, inicializa-o
		if (!dados.current.info) {
			dados.current.info = {}; // Inicializa info se não existir
		}

		if (!Array.isArray(dados.current.info.projetos)) {
			dados.current.info.projetos = []; // Inicializa projetos como um array se não estiver definido
		}

		// Se estamos editando um projeto existente
		if (projetoAtual) {
			const projetoIndex = dados.current.info.projetos.findIndex(proj => proj.codProjeto === projetoAtual.codProjeto);
			if (projetoIndex !== -1) {
				// Atualiza o projeto existente com os novos valores dos campos do modal
				dados.current.info.projetos[projetoIndex] = {
					codProjeto: codProjetoInput,
					nome: [{
						tipo: tipoSw.find(tipo => tipo.id === tipoIdInput),
						linha: linhaSw.find(linha => linha.id === linhaIdInput),
					}],
					nLicenca: nLicencaInput,
					dataInicio: dataInicioInput,
					dataFim: dataFimInput,
					assistenciaRemota: assistenciaRemotaInput,
					tempoAssistencia: tempoAssistenciaInput,
					assistenciaPermitida: assistenciaPermitidaInput,
				};
				console.log("Projeto Editado:", dados.current.info.projetos[projetoIndex]);
			}
		} else {
			// Se não estamos editando, adiciona um novo projeto
			const novoProjeto = {
				codProjeto: codProjetoInput,
				nome: [{
					tipo: tipoSw.find(tipo => tipo.id === tipoIdInput),
					linha: linhaSw.find(linha => linha.id === linhaIdInput),
				}],
				nLicenca: nLicencaInput,
				dataInicio: dataInicioInput,
				dataFim: dataFimInput,
				assistenciaRemota: assistenciaRemotaInput,
				tempoAssistencia: tempoAssistenciaInput,
				assistenciaPermitida: assistenciaPermitidaInput,
			};
			// Adiciona o projeto ao array de projetos
			dados.current.info.projetos.push(novoProjeto);
			console.log("Novo Projeto Adicionado:", novoProjeto);
		}

		// Limpa os campos após adicionar ou editar
		clearModalFields();

		// Fecha o modal
		setIsProjectModalOpen(false);
	};

	// Função para preencher os campos do modal para edição
	const EditProjeto = (codProjeto) => {
		const projeto = dados.current.info.projetos.find(proj => proj.codProjeto === codProjeto);
		if (projeto) {
			setProjetoAtual(projeto); // Armazena o projeto atual para edição
			setCodProjetoInput(projeto.codProjeto);
			setTipoIdInput(projeto.nome[0].tipo.id);
			setLinhaIdInput(projeto.nome[0].linha.id);
			setNLicencaInput(projeto.nLicenca);
			setDataInicioInput(projeto.dataInicio);
			setDataFimInput(projeto.dataFim);
			setAssistenciaRemotaInput(projeto.assistenciaRemota);
			setTempoAssistenciaInput(projeto.tempoAssistencia);
			setAssistenciaPermitidaInput(projeto.assistenciaPermitida);
			setIsProjectModalOpen(true); // Abre o modal para edição
		} else {
			console.log("Projeto não encontrado");
		}
	};

	const DeleteProjeto = (codProjeto) => {
		const index = dados.current.info.projetos.findIndex(projeto => projeto.codProjeto === codProjeto);

		if (index !== -1) {
			dados.current.info.projetos.pop(index, 1);
			console.log("Projeto Apagado:", codProjeto);
		} else {
			console.log("Projeto não encontrado:", codProjeto);
		}
		setRefresh(refresh + 1);
	}

	const openModelResponsavel = (id, nome) => {
		setDepartamentoSelecionado(nome)
		setModalResponsavel(true)
		setDepartamentoId(id)

	}

	const AddResponsavel = () => {



		let aux = dados.current.contacts[0].person_responsables;
		let last = dados.current.contacts[0].person_responsables[dados.current.contacts[0].person_responsables.length - 1];

		if (responsavelInputNome && responsavelInputTel) {
			aux.push({
				id: last ? parseInt(last.id) + 1 : 1,
				nome: responsavelInputNome,
				tel: responsavelInputTel,
				departamentos: [departamentoid]
			}

			)

			setModalResponsavel(false);
		}
		set_dados(dados.current.contacts[0].person_responsables = aux)

		console.log("Campo nome", responsavelInputNome);
		console.log("Telemovel", responsavelInputTel);


		console.log("Responsavel", dados.current.contacts[0].person_responsables);
	};

	const handle_pedido_assistencia = () => {

	};

	const handleAddDepartamento = () => {
		let aux = dados.current.contacts[0].departamentos
		let last = dados.current.contacts[0].departamentos[dados.current.contacts[0].departamentos.length - 1];
		if (departamentoInput) {
			aux.push({ id: last.id + 1, nome: departamentoInput })
			setDepartamentoInput('');
			setIsModalOpen(false);
		}
		set_dados(dados.current.contacts[0].departamentos = aux)

		console.log(departamentoInput);
	};

	const change_country = e => {

		set_cities([])
		set_villages([])

		set_dados(dados.current.addresses[0].city = '');
		set_dados(dados.current.addresses[0].village = '');
		set_dados(dados.current.addresses[0].region = '');

		if (e.value === "Portugal") {

			set_show_district_city_village('')

			if (districts.length === 0) {
				//console.log('DISTRITOS VAZIOS')
				obter_distritos_pt(set_districts)
			}
		}
		else {
			set_show_district_city_village('d-none')
		}

		set_dados(dados.current.addresses[0].country = e.value);
	}

	const change_district = e => {

		set_cities([])
		set_villages([])

		obter_cidades_por_distrito(e.value, set_cities)

		set_dados(dados.current.addresses[0].city = '');
		set_dados(dados.current.addresses[0].village = '');
		set_dados(dados.current.addresses[0].region = e.value);
	}

	const change_city = e => {

		set_villages([])

		obter_freguesias_por_cidade(e.value, set_villages)

		set_dados(dados.current.addresses[0].village = '');
		set_dados(dados.current.addresses[0].city = e.value);
	}

	const change_village = e => {
		set_dados(dados.current.addresses[0].village = e.value);
		set_dados(dados)
	}

	const change_entity_type = e => {
		set_dados(dados.current.info.entity_type = e.value);
	}

	const change_identification_type = e => {
		set_dados(dados.current.info.identification.tipo_identificacao = e.value);
	}

	/*const change_district_by_city = async e => {

		return await obter_distrito_por_cidade(e.value)
			.then(res =>
				change_district({ value: res })
			).catch(() => { return } 
				//alert('Distrito não encontrado!')
			)
	}*/

	const fetch_id_info = async (id_serch) => {

		return await reqGET(`${api_crud_route}/${getTokenInfo().companycode}/${id_serch}`)
			.then(res => {

				if (res.data[0].contacts[0].email === '') {
					res.data[0].contacts[0].email = res.data[0].info.email
				}

				set_dados(dados.current = res.data[0]);
				console.log("Objeto Completo", dados.current = res.data[0])

			})
			.catch(error => alert(error)/*TODO: GO TO FAIL FETCH*/)
	}
	const clean_data = () => {
		// DEEP COPY OF data_interface 
		set_dados(dados.current = JSON.parse(JSON.stringify(data_interface)))
		set_dados(dados.current.info.companycode = getTokenInfo().companycode)
		//console.log(dados.current)
	}

	// PARA INSTANCIAR O COMPONENTE COM O ID 
	//const props_tmp = props
	useEffect(() => {








		clean_data();
		obter_paises_em_pt(set_countries);

		if (getTokenInfo().profile === 'Cliente') {

			set_is_edit(true)

			set_show_delete_button('d-none')

			fetch_id_info(getTokenInfo().id).then(() => {

				//console.log(dados.current)
				if (dados.current.addresses[0].country === 'Portugal') {

					obter_distritos_pt(set_districts)

					obter_cidades_por_distrito(dados.current.addresses[0].region, set_cities)

					obter_freguesias_por_cidade(dados.current.addresses[0].city, set_villages)
					setLoading(false);
				}
				else {
					set_show_district_city_village('d-none')
					setLoading(false);
				}
			})
			return

		}

		try {
			let test = props.location.state.operation;

			if (test === 'edit') {

				console.log('000')

				//console.log('NO EDIT')
				set_is_edit(true)

				set_show_delete_button('')

				fetch_id_info(props.location.state.item['id']).then(() => {

					//console.log(dados.current)
					if (dados.current.addresses[0].country === 'Portugal') {

						obter_distritos_pt(set_districts)

						obter_cidades_por_distrito(dados.current.addresses[0].region, set_cities)

						obter_freguesias_por_cidade(dados.current.addresses[0].city, set_villages)
						setLoading(false);
					}
					else {
						set_show_district_city_village('d-none')
						setLoading(false);
					}
				})
				return
			}
		}
		catch {

			clean_data()

			setLoading(false);

			setRedirect(false);
			return

		}
		// BACK
		//props.history.push(endpoints.list)
		return () => {
			clean_data()
		}

	}, [props])

	const handleSubmit = async e => {
		e.preventDefault();

		if (is_edit === true) {
			//alert('Atualizar PUT')

			Swal.fire({
				title: language[lang].edit_title,
				text: language[lang].edit_text,
				icon: 'question',
				showCancelButton: true,
				confirmButtonColor: '#0095e8',
				cancelButtonColor: '#d9214e',
				confirmButtonText: language[lang].edit_confirm,
				cancelButtonText: language[lang].edit_cancel
			})
				.then((result) => {
					if (result.isConfirmed) {

						if (is_password) {
							let password = new_password;
							dados.current.info.password = passwordHash(password);
						}

						reqPUT(api_crud_route, dados.current)
							.then(() => {
								set_new_password('')
								set_confirm_password('')

								// props.history.push(endpoints.list) 
							})
							.catch(() => Swal.fire(language[lang].edit_error, '', 'info'))
					}
				})
		} else {
			Swal.fire({
				title: language[lang].insert_title,
				text: language[lang].insert_text,
				icon: 'question',
				showCancelButton: true,
				confirmButtonColor: '#0095e8',
				cancelButtonColor: '#d9214e',
				confirmButtonText: language[lang].insert_confirm,
				cancelButtonText: language[lang].insert_cancel
			})
				.then((result) => {
					if (result.isConfirmed) {

						if (is_password) {
							let password = new_password;
							dados.current.info.password = passwordHash(password);
						}

						reqPOST(api_crud_route, dados.current)
							.then(() => {
								set_new_password('')
								set_confirm_password('')

								props.history.push(endpoints.list)
							})
							.catch(() => Swal.fire(language[lang].insert_error, '', 'info'))
					}
				})
		}
	}

	/*const handleSubmitVat = async e => {
		e.preventDefault();

		setLoading(true);
		get_vat_info(dados.current.info.vat)
			.then(res => {
				//console.log('---------- VAT INFO --------------')
				//console.log(res)

				if ((res.data.name !== '---') && (res.data.name !== '')) {
					clean_data();
					set_dados(dados.current.info.vat = res.data.vatNumber);
					set_dados(dados.current.info.name = res.data.name);
					set_dados(dados.current.addresses[0].address_detail = res.data.address);

					let aMorada = res.data.address.split("\n");
					// Verificar se pais é PT
					if (res.data.countryCode === 'pt') {
						//console.log('----------------------> É PT')

						change_country({ value: 'Portugal' })


						set_dados(dados.current.addresses[0].street_name = aMorada[1]);

						let city = aMorada[1];
						if (city !== undefined) {
							city = city.toLowerCase();
							city = city.charAt(0).toUpperCase() + city.slice(1);
							change_district_by_city({ value: city }).then(() => change_city({ value: city }))


							// After District -> City
							change_district_by_city({ value: city }).then(() => change_city({ value: city }))

							let aMoradaCP = aMorada[2].split(" ");
							set_dados(dados.current.addresses[0].postal_code = aMoradaCP[0]);
						}
					} else {
						//console.log('---------------------->NÃO È PT')
						set_dados(dados.current.addresses[0].street_name = aMorada[1]);
					}
				}
				else {

					Swal.fire('VAT não encotrado na base VIES.', '', 'info')

				}
				setLoading(false)
			})

			.catch(error => { setLoading(false); alert(error) });
	}*/

	const handleSubmitPassword = async e => {
		e.preventDefault();

		Swal.fire({
			title: language[lang].edit_title,
			text: language[lang].edit_text,
			icon: 'question',
			showCancelButton: true,
			confirmButtonColor: '#0095e8',
			cancelButtonColor: '#d9214e',
			confirmButtonText: language[lang].edit_confirm,
			cancelButtonText: language[lang].edit_cancel
		})
			.then((result) => {
				if (result.isConfirmed) {
					reqPUT(api_crud_route, dados.current)
						.then(() => { props.history.push(endpoints.list) })
						.catch(() => Swal.fire(language[lang].edit_error, '', 'info'))
				}
			})
	}

	function apagar() {

		Swal.fire({
			title: language[lang].delete_title,
			text: language[lang].delete_text,
			icon: 'question',
			showCancelButton: true,
			confirmButtonColor: '#0095e8',
			cancelButtonColor: '#d9214e',
			confirmButtonText: language[lang].delete_confirm,
			cancelButtonText: language[lang].delete_cancel
		})
			.then((result) => {
				if (result.isConfirmed) {

					reqDELETE(api_crud_route + '/', { id: dados.current.id })
						.then(res => {
							/* alert(res.status === 200 ?
								'Registo Apagado com Sucesso' : 'Problema ao Apagar Registo'); */

							props.history.push(endpoints.list);
						})
						.catch(error => alert(error))

				}
			})
	};


	const load_entity = async (vat, entity) => {
		reqGET(`${api_crud_base}/entities/list/${getTokenInfo().companycode}/${entity}`)
			.then(res => {
				//console.log(res.data)
				// res.data.map((k) => {
				// 	if(k['vat'] === vat) {
				// 		set_dados(dados.current.info.Cliente.id = k['id']);
				// 		set_dados(dados.current.info.Cliente.name = k['name']);
				// 	}
				// });

				let ja_existe = false
				res.data.forEach((k) => {
					//console.log(res.data)
					if (k['vat'] === vat) {
						ja_existe = true
						//set_visible_client_name(true)
						//set_dados(dados.current.info.Cliente.name = k['vat']);
					}
				})

				if (ja_existe === false) {
					//<Link to={{ pathname: '/client_regist', state: { item: vat, operation: 'newFromCredit' } }} />

					//console.log('NãO EXISTE ________________>');
					return

				} else {

					Swal.fire('Já Existe um Registo com este VAT.', '', 'info')

				}
			}
			)
	}

	const handle_change_addresses = (e, addresses_index = 0) => {
		const { name, value } = e.target;

		/* DEBUG*/
		//console.log('NAME:' + name)
		//console.log('Value:' + value)

		set_dados(dados.current.addresses[addresses_index][name] = value)

		//console.log('«««««««««««««««««««««««')
		//console.log('Dados Current:' + JSON.stringify(dados))

	}

	const handle_change_info = (e) => {
		const { name, value } = e.target;

		/* DEBUG*/

		//console.log('NAME:' + name)
		//console.log('Value:' + value)

		set_dados(dados.current.info[name] = value)

		if ((is_edit === false) && (name === 'vat')) {
			if (dados.current.info['vat'].length === 9) {
				load_entity(dados.current.info['vat'], object_type)
			}
		}

		//console.log('«««««««««««««««««««««««')
		//console.log('Dados Current:' + JSON.stringify(dados))

	}

	const handle_change_login = (e) => {
		const { value } = e.target;

		load_entity('username', value, '')
	}

	const handle_change_info_new_password = (e) => {
		const { value } = e.target;

		set_new_password(value)
	}

	const handle_change_password = (e) => {
		const { value } = e.target;

		if (new_password !== '' && value === new_password) {

			set_dados(dados.current.info.password = passwordHash(new_password))
			set_disabled(false)
		}
		else {

			Swal.fire('Password de confirmação diferente da password inserida.', '', 'info')
			set_disabled(true)
		}
	}

	const handle_change_contacts = (e, index = 0) => {
		const { name, value } = e.target;

		/* DEBUG*/

		//console.log('NAME:' + name)
		//console.log('Value:' + value)

		set_dados(dados.current.contacts[index][name] = value)

		//console.log('«««««««««««««««««««««««')
		//console.log('Dados Current:' + JSON.stringify(dados))

	}

	const handle_change_info_identification = (e) => {
		const { name, value } = e.target;

		/* DEBUG*/

		//console.log('NAME:' + name)
		//console.log('Value:' + value)

		set_dados(dados.current.info.identificacao[name] = value)

		//console.log('Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«')
		//console.log('Dados Current:' + JSON.stringify(dados))

	}

	return isloading ?

		<Loader />

		:
		isRedirect
			?
			<Redirect to={endpoints.list} replace />
			:
			<main>
				<div className={`dash-cards header`}>
					<h2 className="dash-title">{language[lang].entity}</h2>
					<p>{language[lang].entity} / {dados.current.id !== '' ? language[lang].entity_edit : language[lang].entity_new}</p>
				</div>

				<div className={`dash-cards body`}>
					<div className="container">

						<div className="row">
							<div className="mb-5 mb-xl-10">
								<div className="card">
									<div className="card-header border-0">
										<div className="card-title m-0">
											<h3 className="fw-bolder m-0">{language[lang].personal_data}</h3>
										</div>
									</div>
									<div id="div-content">
										<form id="form" onSubmit={handleSubmit}>

											<div className="card-body border-top p-4">

												<div className="row mb-5">
													<div className="col-md-8">
														<label className="fs-5 fw-bold mb-2">{language[lang].name}</label>
														<input type="text" name="name" value={dados.current.info.name} className="form-control form-control-lg mb-3 mb-lg-0 rounded-0" placeholder={language[lang].name_placeholder} onChange={handle_change_info} required />
													</div>

													<div className="col-md-4">
														<label className="fs-5 fw-bold mb-2">{language[lang].email}</label>
														<input type="email" pattern={pattern_email} name="email" value={dados.current.info.email != undefined && dados.current.info.email != '' ? dados.current.info.email : dados.current.contacts[0].email} className="form-control form-control-lg mb-3 mb-lg-0 rounded-0" placeholder={language[lang].email_placeholder} onChange={handle_change_contacts} />
													</div>

													<div className="col-md-3 d-none">
														<label className="fs-5 fw-bold mb-2">{language[lang].type}</label>

														<Select
															className="div-select"
															options={entity_types}
															name="client_type"
															value={dados.current.info.entity_type === '' ? null : { label: dados.current.info.entity_type, value: dados.current.info.entity_type }}
															placeholder={language[lang].type_placeholder}
															onChange={change_entity_type}
															styles={custom_select_styles}
														/>
													</div>
												</div>

												{/*
												<div className="row mb-5 d-none">
													<div className="col-md-4">
														<label className="fs-5 fw-bold mb-2">{language[lang].type_identification}</label>
														
														<Select
															className="div-select"
															options={identification_types}
															name="identification_type"
															value={dados.current.info.identification.tipo_identificacao === '' ? null : { label: dados.current.info.identification.tipo_identificacao, value: dados.current.info.identification.tipo_identificacao }}
															placeholder={language[lang].type_identification_placeholder}
															onChange={change_identification_type}
															styles={custom_select_styles}
														/>
													</div>

													<div className="col-md-4">
														<label className="fs-5 fw-bold mb-2">{language[lang].identification_number}</label>
														<input type="text" pattern="\d*" inputMode='numeric' maxLength="11" name="numero_identificacao" value={dados.current.info.identification.numero_identificacao} className="form-control form-control-lg mb-3 mb-lg-0 rounded-0" placeholder={language[lang].identification_number_placeholder} onChange={handle_change_info_identification} />
													</div>

													<div className="col-md-4">
														<label className="fs-5 fw-bold mb-2">{language[lang].identification_validation}</label>
														<input type="date" name="validade_identificacao" value={dados.current.info.identification.validade_identificacao !== '' ? dados.current.info.identification.validade_identificacao : ''} className="form-control form-control-lg mb-3 mb-lg-0 rounded-0" onChange={handle_change_info_identification} /> 
													</div>
												</div>
												*/}

												<div className="row mb-5">
													<div className="col-md-4 d-none">
														<label className="fs-5 fw-bold mb-2">{language[lang].tlf}</label>

														<PhoneInput
															defaultCountry="PT"
															className="form-control form-control-lg mb-3 mb-lg-0 rounded-0"
															placeholder={language[lang].tlf_placeholder}
															value={dados.current.contacts[0].phone !== '' ? dados.current.contacts[0].phone : null}
															onChange={e => set_dados(dados.current.contacts[0].phone = e)}
														/>
													</div>

													<div className="col-md-4">
														<label className="fs-5 fw-bold mb-2">{language[lang].tlm}</label>
														<PhoneInput
															defaultCountry="PT"
															className="form-control form-control-lg mb-3 mb-lg-0 rounded-0"
															placeholder={language[lang].tlm_placeholder}
															value={dados.current.contacts[0].mobile_phone !== '' ? dados.current.contacts[0].mobile_phone : null}
															onChange={e => set_dados(dados.current.contacts[0].mobile_phone = e)}
														/>
													</div>

													<div className="col-md-4">
														<label className="fs-5 fw-bold mb-2">{language[lang].vat}</label>
														<input type="text" pattern={pattern_vat} minLength="9" inputMode='numeric' name="vat" value={dados.current.info.vat} className="form-control form-control-lg mb-3 mb-lg-0 rounded-0" placeholder={language[lang].vat_placeholder} onChange={handle_change_info} required />
													</div>


												</div>

												<div className="row mb-5">
													<div className="col-md-4">
														<label className="fs-5 fw-bold mb-2">{language[lang].country}</label>
														<Select
															className="div-select"
															options={countries}
															name="pais"
															value={dados.current.addresses[0].country === '' ? null : { label: dados.current.addresses[0].country, value: dados.current.addresses[0].country }}
															placeholder={language[lang].country_placeholder}
															onChange={change_country}
															styles={custom_select_styles}
														/>
													</div>

													<div className="col-md-4">
														<label className="fs-5 fw-bold mb-2">{language[lang].district}</label>
														<Select
															className="div-select"
															options={districts}
															name="distrito"
															value={dados.current.addresses[0].region === '' ? null : { label: dados.current.addresses[0].region, value: dados.current.addresses[0].region }}
															placeholder={language[lang].district_placeholder}
															onChange={change_district}
															styles={custom_select_styles}
														/>
													</div>

													<div className="col-md-4">
														<label className="fs-5 fw-bold mb-2">{language[lang].city}</label>
														<Select
															className="div-select"
															options={cities}
															name="concelho"
															value={dados.current.addresses[0].city === '' ? null : { label: dados.current.addresses[0].city, value: dados.current.addresses[0].city }}
															placeholder={language[lang].city_placeholder}
															onChange={change_city}
															styles={custom_select_styles}
														/>
													</div>
												</div>

												<div className="row mb-5">
													<div className="col-md-4">
														<label className="fs-5 fw-bold mb-2">{language[lang].village}</label>
														<Select
															className="div-select"
															options={villages}
															name="freguesia"
															value={dados.current.addresses[0].village === '' ? null : { label: dados.current.addresses[0].village, value: dados.current.addresses[0].village }}
															placeholder={language[lang].village_placeholder}
															onChange={change_village}
															styles={custom_select_styles}
														/>
													</div>

													<div className="col-md-4">
														<label className="fs-5 fw-bold mb-2">{language[lang].local}</label>
														<input type="text" name="localidade" value={dados.current.addresses[0].localidade} className="form-control form-control-lg mb-3 mb-lg-0 rounded-0" placeholder={language[lang].local_placeholder} onChange={handle_change_addresses} />

													</div>

													<div className="col-md-4">
														<label className="fs-5 fw-bold mb-2">{language[lang].postal_code}</label>
														<input type="text" name="postal_code" value={dados.current.addresses[0].postal_code} className="form-control form-control-lg mb-3 mb-lg-0 rounded-0" placeholder={language[lang].postal_code_placeholder} onChange={handle_change_addresses} />
													</div>
												</div>

												<div className="row mb-5">
													<div className="col-md-6">
														<label className="fs-5 fw-bold mb-2">{language[lang].morada}</label>
														<textarea name="address_detail" value={dados.current.addresses[0].address_detail} className="form-control form-control-lg mb-3 mb-lg-0 rounded-0" rows="4" onChange={handle_change_addresses} />
													</div>

												</div>										

												{/* Parte nova */}
												<div>
													<div className="row mb-5">
														<div className="col-md-8 mb-3">
															<label className="fs-5 fw-bold mb-2">{language[lang].adicionar_entidade}</label>
															{/* Button to Open Modal */}
															<button type="button" onClick={() => setIsModalOpen(true)} className="btn btn-primary">
																Adicionar Departamentos
															</button>
														</div>

														{/* List of Departamentos */}
														<div className="col-md-8">
															<h5>Departamentos:</h5>
															<ul>
																{console.log(dados.current.contacts[0].departamentos)}
																{dados.current.contacts[0].departamentos.map((departamento, index) => (
																	<li key={index}>

																		{departamento.nome}
																		{console.log(modalResponsavel)}
																		{console.log("adsasd", departamento)}
																		<button type="button" onClick={() => openModelResponsavel(departamento.id, departamento.nome)}>Adicionar Responsável</button>
																	</li>
																))}
															</ul>
														</div>
													</div>
													{console.log(modalResponsavel)}

													{/* Adicionar Responsávies */}
													{modalResponsavel && (

														<div
															className="modal show"
															style={{
																display: 'flex',
																justifyContent: 'center',
																alignItems: 'center',
																position: 'fixed',
																top: 0,
																left: 0,
																width: '100%',
																height: '100%',
																backgroundColor: 'rgba(0, 0, 0, 0.5)',
																zIndex: 1050,
																pointerEvents: 'none',
															}}
														>
															<div
																className="modal-dialog"
																style={{
																	backgroundColor: 'white',
																	padding: '20px',
																	borderRadius: '5px',
																	width: '300px',
																	pointerEvents: 'auto',
																}}
															>


																<div className="modal-header">
																	<h1>  Departamento {departamentoSelecionado}  </h1>

																</div>
																<h2>Adicionar Novo Responsável</h2>
																<div className="modal-body">
																	<label>

																		<input
																			type="text"
																			className="form-control"
																			value={responsavelInputNome}
																			placeholder='Nome'
																			onChange={(e) => setresponsavelInputNome(e.target.value)}
																			style={{ width: '100%', marginBottom: '10px' }}

																		/>
																		{console.log(responsavelInputNome)}
																	</label>
																	<label>
																		<input
																			type="number"
																			className="form-control"
																			value={responsavelInputTel}
																			placeholder='Contacto'
																			onChange={(e) => setresponsavelInputTel(e.target.value)}
																			style={{ width: '100%', marginBottom: '10px' }}

																		/>
																		{console.log(responsavelInputTel)}
																	</label>
																</div>
																<div className="modal-footer">
																	<button type="button" className="btn btn-primary" onClick={() => AddResponsavel()}>Adicionar</button>
																	<button onClick={() => setModalResponsavel(false)}>Fechar</button>
																</div>
															</div>
														</div>
													)}

													


													<div>
														<div className="row mb-5">
															<div className="col-md-8 mb-3">
																<label className="fs-5 fw-bold mb-2">{language[lang].adicionar_projeto}</label>
																{/* Button to Open Modal */}
																<button type="button" onClick={() => setIsProjectModalOpen(true)} className="btn btn-primary">
																	Adicionar Projetos
																</button>
															</div>

															{/* List of Projetos */}
															<div className="col-md-8">
																<h5>Projetos:</h5>
																<ul>
																	{dados.current && dados.current.info && Array.isArray(dados.current.info.projetos) && dados.current.info.projetos.length > 0
																		? dados.current.info.projetos.map((projeto) => (
																			<li key={projeto.codProjeto}>
																				{projeto.nome && projeto.nome[0] && projeto.nome[0].tipo && projeto.nome[0].linha
																					? `${projeto.nome[0].tipo.nome} ${projeto.nome[0].linha.nome}`
																					: 'Nome do Projeto Indisponível'}
																				<button
																					type="button"
																					onClick={() => EditProjeto(projeto.codProjeto)}
																					aria-label={`Editar o projeto ${projeto.codProjeto}`}
																				>
																					Editar Projeto
																				</button>
																				<button
																					type="button"
																					onClick={() => {
																						if (window.confirm('Tem certeza que deseja apagar este projeto?')) {
																							{ console.log("Estamos a passar o cod projeto:", projeto.codProjeto) }
																							DeleteProjeto(projeto.codProjeto);
																						}
																					}}
																					aria-label={`Apagar o projeto ${projeto.codProjeto}`}
																				>
																					Apagar Projeto
																				</button>
																			</li>
																		))
																		: <li>Nenhum projeto disponível</li>
																	}
																</ul>
															</div>
														</div>

														{/* Adicionar Projetos Modal */}
														{isProjectModalOpen && (
															<div
																className="modal show"
																style={{
																	display: 'flex',
																	justifyContent: 'center',
																	alignItems: 'center',
																	position: 'fixed',
																	top: 0,
																	left: 0,
																	maxWidthdth: '700px',
																	width: '100%',
																	height: '100%',
																	backgroundColor: 'rgba(0, 0, 0, 0.5)',
																	zIndex: 1050,
																	pointerEvents: 'none',

																}}
															>
																<div
																	className="modal-dialog"
																	style={{
																		backgroundColor: 'white',
																		padding: '30px',
																		borderRadius: '10px',
																		width: '600px',
																		maxWidth: '90%',
																		pointerEvents: 'auto',
																	}}
																>
																	<div className="modal-header">
																		<h1>Adicionar Novo Projeto</h1>
																	</div>
																	<div className="modal-body">
																		<label>
																			Código do Projeto
																			<input
																				type="text"
																				className="form-control"
																				value={codProjetoInput}
																				placeholder='Código do Projeto'
																				onChange={(e) => setCodProjetoInput(e.target.value)}
																				style={{ width: '100%', marginBottom: '10px' }}
																			/>
																		</label>
																		<label>
																			Tipo de Software
																			<select
																				className="form-control"
																				value={tipoIdInput}
																				onChange={(e) => setTipoIdInput(parseInt(e.target.value))}
																				style={{ width: '100%', marginBottom: '10px' }}
																			>
																				{tipoSw.map(tipo => (
																					<option key={tipo.id} value={tipo.id}>{tipo.nome}</option>
																				))}
																			</select>
																		</label>
																		<label>
																			Linha de Software
																			<select
																				className="form-control"
																				value={linhaIdInput}
																				onChange={(e) => setLinhaIdInput(parseInt(e.target.value))}
																				style={{ width: '100%', marginBottom: '10px' }}
																			>
																				{linhaSw.map(linha => (
																					<option key={linha.id} value={linha.id}>{linha.nome}</option>
																				))}
																			</select>
																		</label>
																		<label>
																			Licença
																			<input
																				type="text"
																				className="form-control"
																				value={nLicencaInput}
																				placeholder='Número da Licença'
																				onChange={(e) => setNLicencaInput(e.target.value)}
																				style={{ width: '100%', marginBottom: '10px' }}
																			/>
																		</label>
																		<label>
																			Data de Início
																			<input
																				type="date"
																				className="form-control"
																				value={dataInicioInput}
																				onChange={(e) => setDataInicioInput(e.target.value)}
																				style={{ width: '100%', marginBottom: '10px' }}
																			/>
																		</label>
																		<label>
																			Data de Fim
																			<input
																				type="date"
																				className="form-control"
																				value={dataFimInput}
																				onChange={(e) => setDataFimInput(e.target.value)}
																				style={{ width: '100%', marginBottom: '10px' }}
																			/>
																		</label>
																		<label>
																			Assistência Remota
																			<input
																				type="checkbox"
																				className="form-check-input"
																				checked={assistenciaRemotaInput}
																				onChange={(e) => setAssistenciaRemotaInput(e.target.checked)}
																				style={{ marginBottom: '10px' }}
																			/>
																		</label>
																		<label>
																			Tempo de Assistência
																			<input
																				type="text"
																				className="form-control"
																				value={tempoAssistenciaInput}
																				placeholder='Tempo de Assistência'
																				onChange={(e) => setTempoAssistenciaInput(e.target.value)}
																				style={{ width: '100%', marginBottom: '10px' }}
																			/>
																		</label>
																		<label>
																			Assistência Permitida
																			<input
																				type="checkbox"
																				className="form-check-input"
																				checked={assistenciaPermitidaInput}
																				onChange={(e) => setAssistenciaPermitidaInput(e.target.checked)}
																				style={{ marginBottom: '10px' }}
																			/>
																		</label>
																	</div>
																	<div className="modal-footer">
																		<button type="button" className="btn btn-primary" onClick={() => AddProjeto()}>Adicionar</button>
																		<button onClick={() => setIsProjectModalOpen(false)}>Fechar</button>
																	</div>
																</div>
															</div>
														)}
													</div>




													{/* <div>
													 //Mostrar responsaveis por departamento
														<h3>Responsáveis por Departamento {selectedDepartment}</h3>
														<ul>
															{filteredResponsables.length > 0 ? (
																filteredResponsables.map(responsavel => (
																	<li key={responsavel.id}>
																		Nome: {responsavel.nome}, Telemóvel: {responsavel.telemovel}
																	</li>
																))
															) : (
																<li>Nenhum responsável encontrado para este departamento.</li>
															)}
														</ul>

									
													</div> */}





													{/* Modal for Adding Departamentos */}
													{isModalOpen && (
														<div className="modal show" style={{ display: 'block', backgroundColor: 'rgba(0, 0, 0, 0.5)' }}>
															<div className="modal-dialog">
																<div className="modal-content">
																	<div className="modal-header">
																		<h5 className="modal-title">Adicionar Departamento</h5>
																		<button type="button" className="close" onClick={() => setIsModalOpen(false)}>
																			&times;
																		</button>
																	</div>
																	<div className="modal-body">
																		<input
																			type="text"
																			value={departamentoInput}
																			className="form-control"
																			placeholder="Nome do departamento"
																			onChange={(e) => setDepartamentoInput(e.target.value)}
																		/>
																	</div>
																	<div className="modal-footer">
																		<button type="button" className="btn btn-secondary" onClick={() => setIsModalOpen(false)}>Fechar</button>
																		<button type="button" className="btn btn-primary" onClick={handleAddDepartamento}>Adicionar</button>
																	</div>
																</div>
															</div>
														</div>
													)}
												</div>																								
											</div>								
										</form>										
									</div>									
								</div>
								
								
								{/*------------------------------------------------------- NOVO PROJETO - ASSISTENCIA ------------------------------------------------------------------------------*/}
								<div className="card mt-5">
									<div className="card-header border-0 d-flex justify-content-between align-items-center" aria-expanded="true" aria-controls="div_entidade_assistencia">
										<div className="card-title m-0">
											<h3 className="fw-bolder m-0">{language[lang].assistencia}</h3>
										</div>
										<button
											type="button"
											onClick={() => setModalPedidoAssistencia(true)}
											className="btn btn-default btn-sm"
										>
											{language[lang].assistencia_botao}
										</button>
									</div>
									<div className='row mb-6'>
										<div className="row">
											<table>
												<thead>
													<tr>
														<th>Nº</th>
														<th>Prioridade</th>
														<th>Data</th>
														<th>Cliente</th>
														<th>Software</th>
														<th>Assunto</th>
														<th>Responsável</th>
													</tr>
												</thead>
												<tbody>
													{/*
													{Array.from({ length: Math.ceil(dados.current.codProjeto.length / 4) }).map((_, colIndex) =>
														dados.current.codProjeto
															.slice(colIndex * 4, colIndex * 4 + 4)
															.map((codProjeto, index) => (
																<React.Fragment key={index}>
																	{dados.current.clientes
																		.filter(cliente => Array.isArray(cliente.codProjeto) && cliente.codProjeto.includes(codProjeto.id))
																		.map((cliente, clienteIndex) => (
																			<tr key={clienteIndex}>
																				<td>{cliente.id}</td>
																				<td>{cliente.mobile_phone}</td>
																				<td>{cliente.email}</td>
																				<td>{cliente.nome}</td>
																				{clienteIndex === 0 && (
																					<td rowSpan={dados.current.clientes.filter(cliente => Array.isArray(cliente.codProjeto) && cliente.codProjeto.includes(codProjeto.id)).length}>
																						<strong>{codProjeto.nome}</strong>
																					</td>
																				)}																	
																				<td>{cliente.descricao}</td>
																				<td>{cliente.responsavel}</td>
																			</tr>
																		))}
																</React.Fragment>
															))
													)}
													*/}
													{Array.from({ length: Math.ceil(dados.current.contacts[0].departamentos.length / 4) }).map((_, colIndex) =>
														dados.current.contacts[0].departamentos
															.slice(colIndex * 4, colIndex * 4 + 4)
															.map((departamento, index) => (
																<React.Fragment key={index}>
																	{dados.current.contacts[0].person_responsables
																		.filter(person => Array.isArray(person.departamentos) && person.departamentos.includes(departamento.id))
																		.map((person, personIndex) => (
																			<tr key={personIndex}>
																				<td>{person.id}</td>
																				<td>{person.mobile_phone}</td>		
																				<td>{person.email}</td>																		
																				<td>{person.nome}</td>
																				{personIndex === 0 && (
																					<td rowSpan={dados.current.contacts[0].person_responsables.filter(person => Array.isArray(person.departamentos) && person.departamentos.includes(departamento.id)).length}>
																						<strong>{departamento.nome}</strong>
																					</td>
																				)}																				
																				<td>{person.observation}</td>
																				<td>{person.resp}</td>
																			</tr>
																		))}
																</React.Fragment>
															))
													)}													
												</tbody>
											</table>
										</div>
										{modalPedidoAssistencia && (
											<div
												className="modal show d-flex justify-content-center align-items-center"
												style={{ display: 'block', backgroundColor: 'rgba(0, 0, 0, 0.5)' }}
											>
												<div className="modal-dialog" style={{ maxWidth: '700px', width: '90%' }}>
													<div className="modal-content">
														<div className="modal-header">
															<h5 className="modal-title">Software - Pedido de Assistência</h5>
															<button
																type="button"
																className="close"
																onClick={() => setModalPedidoAssistencia(false)}
															>
																&times;
															</button>
														</div>
														<div className="modal-body">
															<div className="mb-3 d-flex">
																<div style={{ flex: 1, marginRight: '20px' }}>
																	{dados.current.contacts[0].departamentos.length > 0 ? (
																		<label className="w-100">
																			Cliente
																			<select
																				value={selectedDepartamentoId}
																				onChange={(e) => setSelectedDepartamentoId(e.target.value)}
																				className="form-control mt-2"
																			>
																				{dados.current.contacts[0].departamentos.map((departamento) => (
																					<option key={departamento.id} value={departamento.id}>
																						{departamento.nome}
																					</option>
																				))}
																			</select>
																		</label>
																	) : (
																		<p>Selecione um cliente</p>
																	)}
																	<label className="form-label w-100 mt-3">
																		Software
																		<select
																			value={selectedDepartamentoId}
																			onChange={(e) => setSelectedDepartamentoId(e.target.value)}
																			className="form-control mt-2"
																		>
																			{dados.current.contacts[0].departamentos.map((departamento) => (
																				<option key={departamento.id} value={departamento.id}>
																					{departamento.nome}
																				</option>
																			))}
																		</select>
																	</label>
																</div>
																<div className="me-3" style={{ flex: 1 }}>
																	<label className="form-label">Prioridade</label>
																	<div>
																		<label className="d-flex align-items-center">
																			<input
																				type="radio"
																				value="1"
																				checked={prioridade === '1'}
																				onChange={(e) => setPrioridade(e.target.value)}
																				style={{ marginRight: '10px' }}
																			/>
																			Imediato
																		</label>
																	</div>
																	<div>
																		<label className="d-flex align-items-center">
																			<input
																				type="radio"
																				value="2"
																				checked={prioridade === '2'}
																				onChange={(e) => setPrioridade(e.target.value)}
																				style={{ marginRight: '10px' }}
																			/>
																			Urgente
																		</label>
																	</div>
																	<div>
																		<label className="d-flex align-items-center">
																			<input
																				type="radio"
																				value="3"
																				checked={prioridade === '3'}
																				onChange={(e) => setPrioridade(e.target.value)}
																				style={{ marginRight: '10px' }}
																			/>
																			Pouco Urgente
																		</label>
																	</div>
																	<div>
																		<label className="d-flex align-items-center">
																			<input
																				type="radio"
																				value="4"
																				checked={prioridade === '4'}
																				onChange={(e) => setPrioridade(e.target.value)}
																				style={{ marginRight: '10px' }}
																			/>
																			Não Urgente
																		</label>
																	</div>
																</div>
															</div>
															<div className="mb-3">
																<label>
																	Assunto
																	<textarea
																		value={responsavelInputEmail}
																		onChange={(e) => setresponsavelInputEmail(e.target.value)}
																		className="form-control mt-2"
																		rows={8}
																		style={{ width: '100%', minWidth: '600px' }}
																	/>
																</label>
															</div>
															<div className="mb-3">
																<label>
																	Responsável pela solicitação
																	<select
																		value={selectedDepartamentoId}
																		onChange={(e) => setSelectedDepartamentoId(e.target.value)}
																		className="form-control mt-2"
																	>
																		{dados.current.contacts[0].departamentos.map((departamento) => (
																			<option key={departamento.id} value={departamento.id}>
																				{departamento.nome}
																			</option>
																		))}
																	</select>
																</label>
															</div>
														</div>
														<div className="modal-footer">
															<button
																type="button"
																className="btn btn-default"
																onClick={handle_pedido_assistencia}
															>
																Fazer pedido de assistência
															</button>
														</div>
													</div>
												</div>
											</div>
										)}
									</div>
								</div>
								{/*------------------------------------------------------- NOVO PROJETO - ASSISTENCIA ------------------------------------------------------------------------------*/}
								<div className="card mt-5">
									<div className="card-header border-0" aria-expanded="true" aria-controls="div_entidade_password">
										<div className="card-title m-0">
											<h3 className="fw-bolder m-0">{language[lang].login_data}</h3>
										</div>
									</div>
									<div id="div_entidade_password" className="collapse show">
										<form id="form_user" onSubmit={handleSubmitPassword}>

											<div className="card-body border-top p-4">

												<div className="row mb-6">
													<div className="col-md-4 fv-row">
														<label className="fs-5 fw-bold mb-2">{language[lang].username}</label>
														<input type="text" name="username" value={dados.current.info.username} pattern="[a-zA-Z\u00C0-\u00FF.]+" className="form-control form-control-lg mb-3 mb-lg-0 rounded-0" placeholder={language[lang].username_placeholder} onChange={handle_change_info} onBlur={handle_change_login} autoComplete="off" />
													</div>
													<div className="col-md-4 fv-row">
														<label className="fs-5 fw-bold mb-2">{language[lang].password}</label>
														<input type="password" name="password" value={new_password} min="9" title="A password deve de conter pelo menos 9 digitos alfa-númericos" className="form-control form-control-lg mb-3 mb-lg-0 rounded-0" placeholder={language[lang].password_placeholder} onChange={handle_change_info_new_password} autoComplete="off" />
													</div>
													<div className="col-md-4 fv-row">
														<label className="fs-5 fw-bold mb-2">{language[lang].password_confirmation}</label>
														<input type="password" name="password_conf" defaultValue={confirm_password} min="9" className="form-control form-control-lg mb-3 mb-lg-0 rounded-0" placeholder={language[lang].password_placeholder} onBlur={handle_change_password} autoComplete="off" />
													</div>
												</div>

												<div className="card-footer d-flex justify-content-end py-6 px-9 d-none">
													<Link className="btn btn-light btn-active-light-primary me-2" to={{ pathname: endpoints.list }}  >
														<span>{language[lang].cancel}</span>
													</Link>

													<button onClick={() => apagar(dados.current.id)} className={show_delete_button ? "btn btn-danger me-2" : "d-none"}>
														<span>{language[lang].delete}</span>
													</button>

													<button type="submit" form="form_user" className="btn btn-primary">
														<span>{language[lang].save}</span>
													</button>
												</div>
											</div>
										</form>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div >

				<div className={'dash-cards footer'}>
					<nav className="navbar bottom-navbar navbar-light">
						<div className="navbar-footer">
							<ul className="navbar-nav float-left"></ul>
							<ul className="navbar-nav float-right">
								<li className={(getTokenInfo().profile === 'Cliente') ? 'd-none' : "nav-item" + ' ' + getTokenInfo().profile}>
									<Link className="nav-link btn-cancel" to={{ pathname: endpoints.list }}  >
                                        <i className="bi bi-chevron-left me-2"></i>
                                        <span>{language[lang].back}</span>
									</Link>
								</li>
								<li className={"nav-item " + show_delete_button}>
									<button type="button" onClick={() => apagar(dados.current.id)} className="nav-link btn-delete">
										<i className="bi bi-trash3 me-2"></i>
										<span>{language[lang].delete}</span>
									</button>
								</li>
								<li className="nav-item">
									<button type="submit" form="form" className="nav-link">
										<i className="bi bi-floppy me-2"></i>
										<span>{language[lang].save}</span>
									</button>
								</li>
							</ul>
						</div>
					</nav>
				</div>
			</main >
}
